/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InteractionType } from '@azure/msal-browser';
import { useLocation } from 'react-router-dom';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/authConfig';
import appSettings from '../../appSettings';
import constants from '../../constants';
import { fetchAgentPortalProfileInfoFailure, fetchAgentPortalProfileInfoSuccess, fetchContactProfileInfoFailure, fetchContactProfileInfoSuccess, setAgencyId, setAgents, setCriticalBannerState, setCurrentUserState, setCustomLinks, setEnrollments, setFromFederation, setFromSignup, setLoadingState, setPreferences, setWebAlerts } from '../../actions/actions';
import { createEnrollment, createNewUser, agentPortalAlertsReq, fetchAgentPortalProfile, updateContact, updateEnrollmentProperty } from '../../common/services/Services';
import { fetchContactProfile, fetchDomain, fetchVerifyUser, modernLinkRedirect } from '../../common/services/proxyServices';
import { formatAgentsList, getAgencyName, getLinks, getPreferenceValue, initiateErrorBanner, isNewUserName, reorderNotifications, replacePath, resetReducers, stripUserDescription, updateAndGetSelectedEnrollment } from '../../common/utilities/CommonHelperUtil';
import { dispatchCurrentAuth, getRefreshToken, handleAuthSuccessFail, setAgencyAccountId, checkTokenExpiry } from '../../common/utilities/AuthHelperUtil.js';
import { displayBannerErrors, getBanner, getDetailedBanner, resetGlobalBanner, setInactiveUserBanner } from '../../common/utilities/CustomBannerUtil';
import { handleUserActions } from '../../common/utilities/userActions.js';
import { CommonModal, ErrorComponent, LegalFormsComponent, LoadingComponent, ShopfloorChatbot, ShopfloorHeader, UserSwitchModal } from '../../components';
import CommonBannerComponent from '../../components/common/CommonBannerComponent/CommonBannerComponent';
import { AccountPrefPage, AddUserPage, AdvancedSearchPage, AgentShopfloorHome } from '..';
import '../../common/theme/CommonStyles.scss';

const AgentShopfloor = ({scrollToTop, toggleChatbot, openChatbot, setFirstEntry, setEntryFromFederation}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { instance, inProgress, accounts } = useMsal();
  const queryParams = new URLSearchParams(location.search);
  const authRequest = { ...loginRequest }; 
  authRequest.extraQueryParameters.userData = queryParams.toString().replace('userdata=', '');
  if (
  location.pathname === '/signup' 
  ) {
  authRequest.prompt = 'login';
  }
  const userNames = useSelector(state => state.enrollments);
  const loading = useSelector(state => state.loading);
  const fromSignup = useSelector(state => state.fromSignup);
  const fromFederation = useSelector(state => state.fromFederation);
  const currentlySelectedUser = useSelector(state => state.currentUser);
  const notifications = useSelector(state => state.webAlerts);
  const contact = useSelector(state => state.contact);
  const ssoAgent = useSelector(state => state.agencyId);
  const showCriticalBanner = useSelector(state => state.criticalBannerState);
  const [agencyName, setAgencyName] = useState({});
  const [contactInfoData, setContactInfoData] = useState({});
  const [hasMultipleUsernames, setHasMultipleUsernames] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ current: '', new: '' });
  const [currentUser, setCurrentUser] = useState('');
  const [prefPage, setPrefPage] = useState('');
  const [showGlobalBanner, setShowGlobalBanner] = useState(false);
  const [showMinifiedHeader, setShowMinifiedHeader] = useState(false);
  const [agentAMSuitePreference, setAgentAMSuitePreference] = useState('');
  const [isAgentDropdownOpen, setAgentDropdownOpen] = useState(queryParams.get('dropdown') === 'true' ? true : false);
  const [isNotificationMenuOpen, setNotificationMenuOpen] = useState(false);
  const [quickLinkData, setQuickLinkData] = useState([]);
  const [legalFlowComplete, setLegalFlowComplete] = useState(undefined);
  const [currentStep, setCurrentStep] = useState(1);
  let [boxLinkData, setBoxLinkData] = useState([]);
  const [ciamAccountExists, setCiamAccountExists] = useState(false);
  const [ciamName, setCiamName] = useState({});
  const [reportingRedirect, setReportingRedirect] = useState('/');
  const [showReportingModal, setShowReportingModal] = useState(false);
  const [statusFlags, setStatusFlags] = useState({
    isAddedUser: false,
    isMFAUpdated: false,
    isUserUpdated: false,
    isPWUpdated: false
  });
  const agentsList = useSelector(state => state.agents);
  const managingGroupList = formatAgentsList(agentsList);

  const userLogout = queryParams.toString().replace('logout=', '');
  const [globalBannerProps, setGlobalBannerProps] = useState({});
  let user;

  const filterSSOEnrollments = async (contactProfileInfo) => {
    if((!!ssoAgent && ssoAgent !== '') && (contactProfileInfo && contactProfileInfo.enrollments !== undefined)) {
      contactProfileInfo.enrollments = contactProfileInfo.enrollments.filter(enrollment => enrollment.domain && enrollment.domain.toLowerCase() === ssoAgent.toLowerCase());
    }
  }
  
  const handleChange = (event) => {
     if(event.target.value !== undefined && event.target.value !== 0) {
       switchUser(event.target.value);
     } else {
       //this is from onClick event of selecting a different user from the primary button dropdown menu
       switchUser(event.target.innerHTML);
    }
  };

  const switchUser = (newUsername) => {
    setSelectedUser({ current: `${currentUser.prismId}`, new: newUsername });
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedUser({ current: '', new: currentUser.prismId });
  };

  const handleConfirmModal = (newUsername) => {
    setOpenModal(false);
    dispatch(setCurrentUserState(newUsername));
    fetchData(newUsername);
  };

  const toggleDropdown = () => {
    setAgentDropdownOpen(!isAgentDropdownOpen);
  };

  const openNotifications = () => {
    setNotificationMenuOpen(prevState => !prevState);
    dismissCriticalBanner();
  }

  const criticalNotifications = () => {
    for (const message of notifications) {
      if (message.priority && message.priority.includes('critical')) {
        return message;
      }
    }
    return null;
  };

  const refreshToken = async () =>  {
    return await getRefreshToken(instance, accounts)
  }

  async function navAgencyManagement() {
    const modernlinkUrl = await modernLinkRedirect(currentUser.prismId);
    window.open(modernlinkUrl, '_self');
  }

  async function showReportingCommonModal() {
    const description = currentUser.description ? `${currentUser.description}` : '';
    const encodedDescription = encodeURIComponent(description);
    const url = `${appSettings.REPORTING_COGNOS_URL}(@burstKey=%27${encodedDescription}%27)]`;
    setReportingRedirect(url);
    setShowReportingModal(prevState => !prevState);
  }

  async function checkContactInfo(contactProfileInfo, account) {
    const contactInfo = contactProfileInfo.contact ? contactProfileInfo.contact : [];
    setContactInfoData(contactInfo);
    const enrollments = contactProfileInfo.enrollments ? contactProfileInfo.enrollments : [];
    const ciamInfoExists = !!(account.email && account.oid && account.strongAuthenticationPhoneNumber);
    if(ciamInfoExists) {
      setCiamName({ lastName: account.family_name });
      setLegalFlowComplete(true)
      if(Object.keys(contactInfo).length === 0 || contactInfo?.message === 'Contact not found.') {
        setCiamAccountExists(true);
        replacePath(location, '/add-user');
        return true;
      }
      if(enrollments.length === 0) {
        replacePath(location, '/add-user');
        return true;
      }
    }

    if ((contactInfo.mobilePhone && contactInfo.mobilePhone !== '') && (contactInfo.mobilePhone === account.strongAuthenticationPhoneNumber)) {
        return false;
    }

    contactInfo.mobilePhone = account.strongAuthenticationPhoneNumber;

    const { token } = await refreshToken();
    let userData = {
        ciamId: account.oid,
        emailAddress: account.email,
        updatedMobilePhone: account.strongAuthenticationPhoneNumber
    };
    
    updateContact(userData, token);
    return;
  }

  const checkPreferences = async (newPreferences) => {
    if ((newPreferences && newPreferences.length > 0) && getPreferenceValue(newPreferences, 'preferenceName', 'preferenceValue', 'TERMS_CONDITIONS') === 'ACCEPTED') {
      setCurrentStep(2);
      return;
    }
    setCurrentStep(1);
  }

  const dismissCriticalBanner = () => {
    setShowGlobalBanner(prevState => !prevState);
    dispatch(setCriticalBannerState(false));
  } 

  useEffect(() => {
    handleAuthSuccessFail(instance, loginRequest);
    setStatusFlags({
        isAddedUser: queryParams.get('add') === 'true',
        isMFAUpdated: queryParams.get('mfaUpdated') === 'true',
        isUserUpdated: queryParams.get('userUpdated') === 'true',
        isPWUpdated: queryParams.get('pwUpdated') === 'true'
    });
    scrollToTop();
  }, []);


  useEffect(() => {
    const setActiveAccount = async () => {
      setLoadingState(true);
      if (accounts.length > 0 && inProgress === 'none') {
        instance.setActiveAccount(accounts[0]);
        try {
          dispatch(setLoadingState(true));
          const userName = accounts[0].idTokenClaims.is_username;
          let contactProfileData = null;
          contactProfileData = await firstTimeSetup(userName);
          fetchData(false, contactProfileData);
        } catch (error) {
          if(error && error.message.includes('No username found for initial setup.')) {
            setGlobalBannerProps(getDetailedBanner('success', 'Welcome!',  "To start using AMsuite+, we'll need a little more information.", null, { text: 'Add user', action: replacePath(location, '/add-user') }, () => { dismissCriticalBanner() }));
          } else {
            setGlobalBannerProps(getDetailedBanner(constants.errorText, 'Error message', 'No username found for initial setup.', null, { text: 'Add user', action: replacePath(location, '/add-user') }, () => { dismissCriticalBanner() }));
          }
          setShowGlobalBanner(true);
          setShowMinifiedHeader(true);
          setLegalFlowComplete(true);
          replacePath(location, '/add-user');
          dispatch(setLoadingState(false));
        }
      }
    };

    setActiveAccount();
  }, [inProgress, instance, accounts]);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
        checkTokenExpiry(instance, accounts);
        dispatchCurrentAuth(dispatch, accounts, setFirstEntry, setEntryFromFederation, fromFederation, setFromFederation, fromSignup, setFromSignup, setAgencyId)
        setAgencyAccountId(dispatch, accounts, setAgencyId, ssoAgent)
    }
  }, [accounts]);
 
  useEffect(() => {
    const criticalNotification = notifications.length > 0 ? criticalNotifications() : null;
    if (criticalNotification) {
      const criticalMessage = criticalNotification.body;
      const formattedCriticalMessage = criticalMessage.replace(/\n/g, '');
      if(showCriticalBanner && !showGlobalBanner) {
        setGlobalBannerProps(getDetailedBanner(constants.errorText, criticalNotification.title, formattedCriticalMessage, 'To see more notifications, click the notification bell', { text: 'Open notifications ', action: openNotifications }, () => { dismissCriticalBanner() }));
        setShowGlobalBanner(true);
      }
    }
  }, [notifications, showGlobalBanner]); 

  const handleNavigate = async (userName) => {
      if (userName) {
          const newURL = agentAMSuitePreference !== undefined && agentAMSuitePreference.toLowerCase() !== constants.amsuite ? await modernLinkRedirect(userName, null, false, true) : await modernLinkRedirect(userName, null, true, false);
          return newURL;
      }
      return '';
  };

  const openGlobalBanner = (errorMsg) => {
    initiateErrorBanner(setGlobalBannerProps, setShowGlobalBanner, errorMsg, dismissCriticalBanner);
    dispatch(setLoadingState(false));
  }

  function showUserBanner(successMsg){
    let successBanner = getBanner('success', () => { dismissCriticalBanner() });
    successBanner.bannerTitle = successMsg;
    setGlobalBannerProps(successBanner);
    setShowGlobalBanner(true);
  }

  const setNavItem = async (itemName, resp, selectedGUID, defaultUser, successMsg) => {
    dispatch(setLoadingState(true));
    if(resp?.success) {
      const updatedIndex = userNames.findIndex(userName => userName.guid === selectedGUID);
      userNames.forEach((value, index) => {
        if (index !== updatedIndex) {
          value.is_default = false;
        }
      });
      userNames[updatedIndex].is_default = true;
      dispatch(setEnrollments(userNames));
      dispatch(setCurrentUserState(userNames[updatedIndex].prismId));
      showUserBanner(successMsg);
      refreshToken();
    }

    if(resp?.status && resp.status.toLowerCase() === 'success') {
      dispatch(setCurrentUserState(userNames[0].prismId));
      if(selectedGUID === defaultUser) {
        await fetchData(false);
        return;
      }
      const remainingUserNames = userNames.filter(userName => userName.guid !== selectedGUID);
      dispatch(setEnrollments(remainingUserNames));
      showUserBanner(successMsg);
      refreshToken();
    }

    dispatch(setLoadingState(false));
    setPrefPage(itemName);
  }

  const updateReducers = async (contactProfileInfo, agentProfileInfo, webAlerts, userInfo ) => {
    if (contactProfileInfo?.preferences) {
        dispatch(setPreferences(contactProfileInfo.preferences));
        delete contactProfileInfo.preferences;
    }
    
    if (contactProfileInfo?.enrollments) {
        dispatch(setEnrollments(contactProfileInfo.enrollments));
        delete contactProfileInfo.enrollments;
    }
    
    if (contactProfileInfo?.contact) {
        dispatch(fetchContactProfileInfoSuccess(contactProfileInfo.contact));
    }
    
    if (agentProfileInfo?.agents) {
        dispatch(setAgents(agentProfileInfo.agents));
        delete agentProfileInfo.agents;
    }
    
    dispatch(fetchAgentPortalProfileInfoSuccess(agentProfileInfo));
    
    if (agentProfileInfo?.customLinks) {
        dispatch(setCustomLinks(agentProfileInfo.customLinks));
    }
    if (webAlerts) {
        dispatch(setWebAlerts(webAlerts));
    }
    if (userInfo?.prismId) {
        dispatch(setCurrentUserState(userInfo.prismId));
    }
    
    setAgentAMSuitePreference(agentProfileInfo.amsuitePreference ? agentProfileInfo.amsuitePreference : '' );
    const navTileLinks = getLinks(agentProfileInfo.customLinks, constants.NAVTILELINK);

    // Move the initialization of boxLinkData inside updateReducers since it depends on current agentProfile customLinks
    // it is assumed that customLink will contain 4 links under "NavTileLink" category, where first one it ignored since AMSuite preference is based on
    // amsuitePreference
    boxLinkData = [
      { text: constants.AMSUITE_PC, url: '', boxStyle: 'blue' },
      { text: navTileLinks[0] ? navTileLinks[0].display : '', url: navTileLinks[0] ? navTileLinks[0].url : '', boxStyle: 'lightBlue' },
      { text: navTileLinks[1] ? navTileLinks[1].display : '', url: navTileLinks[1] ? navTileLinks[1].url : '', boxStyle: 'purple' },
      { text: navTileLinks[2] ? navTileLinks[2].display : '', url: navTileLinks[2] ? navTileLinks[2].url : '', boxStyle: 'lightPurple' },
    ];
    setBoxLinkData(boxLinkData);
    setQuickLinkData(getLinks(agentProfileInfo.customLinks, constants.QUICKLINK));    
  };
 
 // Function handling first-time setup logic
 const firstTimeSetup = async (userName) => {
   const { token, idTokenAccount } = await refreshToken();
   const account = idTokenAccount.idTokenClaims;
   const effectiveUsername = userName && userName.length > 0 ? userName : account.is_username;
   const contactProfileInfo = await fetchContactProfile(account.email, account.sub, null, token);
   // Check whether the username is new and handle accordingly
   if (await isNewUserName(contactProfileInfo, effectiveUsername)) {
      if (!effectiveUsername) {
        setCiamName({ lastName: account.family_name });
        setCiamAccountExists(true);
        throw new Error('No username found for initial setup.');
      }
      let verifyUserResp = await fetchVerifyUser({username: effectiveUsername});
      if(!verifyUserResp.canEnroll && verifyUserResp.errorCode === 'E200') {
        verifyUserResp =  await fetchVerifyUser({username: effectiveUsername, npn: verifyUserResp.data.userData.npn});
      }
      if (verifyUserResp.canEnroll) {
        const licensedValues = verifyUserResp.data.userData;
        const domain = licensedValues && licensedValues.mGroupName ? await fetchDomain(licensedValues.mGroupName) : null;
        const baseEnrollmentData = { ciamId: account.oid, prismId: effectiveUsername, lpId: licensedValues.lpId, domain: domain, prid: licensedValues.prid, mGroupName: licensedValues.mGroupName};
        //If the agent has an existing account with or without enrollments.
        if (contactProfileInfo.enrollments) {
          const enrollmentData = { ...baseEnrollmentData, contactId: contactProfileInfo.contact.contactId, email: account.email, mobilePhone: account.strongAuthenticationPhoneNumber, firstName: licensedValues.firstName, lastName: licensedValues.lastName, dob: licensedValues.dob, npn: licensedValues.npn};
          const respCreateEnrollment = await createEnrollment(enrollmentData, token);
          if (respCreateEnrollment.status === 'Success') {
            dispatch(setCurrentUserState(effectiveUsername));
            return null;
          }
        } else {
          // New Account
          const newUserEnrollmentData = {...baseEnrollmentData, email: account.email, mobilePhone: account.strongAuthenticationPhoneNumber, firstName: licensedValues.firstName, lastName: licensedValues.lastName, dob: licensedValues.dob, npn: licensedValues.npn};
          await createNewUser(newUserEnrollmentData, token);
          return null;
        }
     }

    return null;
   }
   return contactProfileInfo;
 };

  const manageAndPersistEnrollments = (contactProfileInfo, userName, token) => {
    const enrollments = contactProfileInfo.enrollments;

    try {
      const {updatedEnrollments, newlySelectedUser} = updateAndGetSelectedEnrollment(enrollments, userName, token);
      // Persist the local enrollments
      contactProfileInfo.enrollments = updatedEnrollments;
      return newlySelectedUser;
    } catch (error) {
      return null; 
    }
  };

  const setAgentState = (agentProfileInfo, account, contactProfileInfo, webAlerts) => {
    scrollToTop();
    setAgencyName(getAgencyName(agentProfileInfo.chAsgnId, agentProfileInfo.agents) || account.name);        
    setCurrentUser(user);
    setSelectedUser({ current: '', new: user.prismId });
    updateReducers(contactProfileInfo, agentProfileInfo, webAlerts, user);
    dispatch(setLoadingState(false));
    handleUserActions(statusFlags, userLogout, setStatusFlags, setGlobalBannerProps, getBanner, showUserBanner, setShowGlobalBanner, instance);
  }

  const fetchData = async (newUser, contactProfileData) => {
    dispatch(setLoadingState(true));
    await resetReducers(dispatch);
    const { token, idTokenAccount } = await refreshToken();
    if (accounts.length > 0) {
      const account = idTokenAccount.idTokenClaims;
      const userSelected = (newUser !== false && newUser !== undefined) || (currentlySelectedUser !== null);
      try {
        const contactProfileInfo = contactProfileData ?? await fetchContactProfile(account.email, account.sub, null, token);
        await filterSSOEnrollments(contactProfileInfo);
        if(await checkContactInfo(contactProfileInfo, account)) { 
          dispatch(fetchContactProfileInfoSuccess(contactProfileInfo.contact));
          dispatch(setLoadingState(false));
          return; 
        }
        setLegalFlowComplete(false);
        await checkPreferences(contactProfileInfo.preferences);
        if(userSelected) {
          newUser = newUser ? stripUserDescription(newUser) : stripUserDescription(currentlySelectedUser); 
        }
        user = manageAndPersistEnrollments(contactProfileInfo, newUser, token);
        const agentProfileInfo = await fetchAgentPortalProfile(user.prismId, user.domain, token);
        if(agentProfileInfo?.status !== 'Inactive') {
          updateEnrollmentProperty(user.guid, 'new_lastaccessdate', new Date().toISOString(), token);
        }
        setHasMultipleUsernames(contactProfileInfo.enrollments.length > 1);
        let webAlerts = await agentPortalAlertsReq(token);
        const alertsArray = webAlerts?.data ?? [];
        webAlerts = alertsArray.length > 0 ? reorderNotifications(alertsArray) : [];
        resetGlobalBanner(setGlobalBannerProps, setShowGlobalBanner, setShowMinifiedHeader);
        if(userSelected && Object.keys(agentProfileInfo).length === 0) {
          setSelectedUser({ current: '', new: currentUser.prismId });
          throw new Error();
        }
        if((agentProfileInfo?.status?.toLowerCase() === 'inactive')) {
          setInactiveUserBanner(setGlobalBannerProps, setShowGlobalBanner, setShowMinifiedHeader, location);
        }
        setAgentState(agentProfileInfo, account, contactProfileInfo, webAlerts);
      } catch (err) {
        displayBannerErrors(err, dispatch, fetchContactProfileInfoFailure, fetchAgentPortalProfileInfoFailure, openGlobalBanner, setShowMinifiedHeader, setLegalFlowComplete, setLoadingState);
      }
    }
  };  

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <MsalAuthenticationTemplate
    interactionType={InteractionType.Redirect}
    authenticationRequest={authRequest}
    errorComponent={ErrorComponent}
    loadingComponent={LoadingComponent}>
      <CommonModal type={constants.restrict}/>
      {showReportingModal && <CommonModal type={constants.reports} action={() => {setShowReportingModal(false); window.open(reportingRedirect, '_blank');}} toggleModal={() => setShowReportingModal(prevState => !prevState)} />}
      { (legalFlowComplete !== true && accounts.length > 0) && 
          <LegalFormsComponent user={currentUser.prismId} refreshToken={refreshToken} accountInfo={accounts[0].idTokenClaims} contactId={contact.contactId} currentStep={currentStep} setLegalFlowComplete={setLegalFlowComplete} setCurrentStep={setCurrentStep} setGlobalBannerProps={setGlobalBannerProps} setShowGlobalBanner={setShowGlobalBanner} setShowMinifiedHeader={setShowMinifiedHeader}/>
      }
      { (legalFlowComplete === true && accounts.length > 0) &&  
       <>
        <ShopfloorHeader handleChange={handleChange} selectedUser={selectedUser} showMinifiedHeader={showMinifiedHeader} toggleDropdown={toggleDropdown} toggleChatbot={toggleChatbot} setNotificationMenuOpen={setNotificationMenuOpen} isNotificationMenuOpen={isNotificationMenuOpen} navAgencyManagement={navAgencyManagement} showReportingCommonModal={showReportingCommonModal}/>
        { selectedUser.current !== selectedUser.new &&
          <UserSwitchModal
            open={openModal}
            onClose={handleCloseModal}
            onConfirm={handleConfirmModal}
            selectedUser={selectedUser}
            fetchData={fetchData}
          />  
        }
      
        {showGlobalBanner && <CommonBannerComponent bannerState='global' bannerProps={globalBannerProps} />}
        {(location.pathname === '/' || location.pathname === '/signup' || location.pathname === '/federated') && ( 
          <AgentShopfloorHome refreshToken={refreshToken} hasMultipleUsernames={hasMultipleUsernames} selectedUser={selectedUser} handleChange={handleChange} boxLinkData={boxLinkData} quickLinkData={quickLinkData} accounts={accounts} currentUser={currentUser} agencyName={agencyName} setAgentDropdownOpen={setAgentDropdownOpen} isAgentDropdownOpen={isAgentDropdownOpen} 
          setShowGlobalBanner={setShowGlobalBanner} setGlobalBannerProps={setGlobalBannerProps} scrollToTop={scrollToTop} navAgencyManagement={navAgencyManagement} showReportingCommonModal={showReportingCommonModal} openGlobalBanner={openGlobalBanner} handleNavigate={handleNavigate}/>
        )}
        {(location.pathname === '/account-preferences' && Object.keys(contactInfoData).length !== 0) && ( 
          <AccountPrefPage refreshToken={refreshToken} accountInfo={accounts[0].idTokenClaims} contactInfo={contactInfoData} scrollToTop={scrollToTop} setNavItem={setNavItem} prefPage={prefPage === '' ? 'MyProfile' : prefPage} openGlobalBanner={openGlobalBanner} />
        )}
        {(location.pathname === '/advanced-search' && Object.keys(contactInfoData).length !== 0) && ( 
          <AdvancedSearchPage refreshToken={refreshToken} accountInfo={accounts[0].idTokenClaims} contactInfo={contactInfoData} user={currentUser.prismId} scrollToTop={scrollToTop} openGlobalBanner={openGlobalBanner} hideErrorBanner={() => { setShowGlobalBanner(false) }} />
        )}
        {(location.pathname === '/add-user' && accounts.length > 0) && ( 
          <AddUserPage refreshToken={refreshToken} ciamAccountExists={ciamAccountExists} ciamName={ciamName} accountInfo={accounts[0].idTokenClaims} contactInfo={contactInfoData} openGlobalBanner={openGlobalBanner} />
        )}     
         <ShopfloorChatbot toggleChatbot={toggleChatbot} openChatbot={openChatbot} username={currentUser.prismId} groupName={managingGroupList.toLowerCase()}/> 
      </>
    }
    </MsalAuthenticationTemplate>
  );
}

export default AgentShopfloor;
